/* Potvorky – product page interactions: gallery, bundle picker, add-to-cart, review carousel, FAQ, sticky ATC */
(function () {
  'use strict';

  /* ---------- Gallery ---------- */
  function initGallery() {
    var gallery = document.querySelector('[data-pv-gallery]');
    if (!gallery) return;
    var mainImg = gallery.querySelector('[data-pv-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-pv-gallery-thumb]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var fullSrc = thumb.getAttribute('data-full-src');
        if (!fullSrc || !mainImg) return;
        mainImg.setAttribute('src', fullSrc);
        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  }

  function syncGalleryToImage(imageUrl) {
    if (!imageUrl) return;
    var gallery = document.querySelector('[data-pv-gallery]');
    if (!gallery) return;
    var mainImg = gallery.querySelector('[data-pv-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-pv-gallery-thumb]');
    var base = imageUrl.split('?')[0];
    var match = null;
    thumbs.forEach(function (t) {
      var thumbBase = (t.getAttribute('data-full-src') || '').split('?')[0];
      if (thumbBase === base) match = t;
    });
    if (!match || !mainImg) return;
    mainImg.setAttribute('src', match.getAttribute('data-full-src'));
    thumbs.forEach(function (t) {
      t.classList.remove('is-active');
    });
    match.classList.add('is-active');
  }

  /* ---------- Bundle picker ---------- */
  function initBundle() {
    var root = document.querySelector('[data-pv-bundle]');
    if (!root) return;

    var variantsScript = document.querySelector('[data-pv-variants-json]');
    var variants = [];
    try {
      variants = JSON.parse(variantsScript ? variantsScript.textContent : '[]');
    } catch (e) {
      variants = [];
    }

    var cards = root.querySelectorAll('[data-pv-tier]');
    var quantityInput = document.querySelector('[data-pv-quantity-input]');
    var variantIdInput = document.querySelector('[data-pv-variant-id-input]');

    function findVariant(color, size) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.option1 === color && v.option2 === size) return v;
      }
      return null;
    }

    function updateUnitVariant(unitRow) {
      var colorSelect = unitRow.querySelector('[data-pv-unit-color]');
      var sizeSelect = unitRow.querySelector('[data-pv-unit-size]');
      if (!colorSelect || !sizeSelect) return null;
      return findVariant(colorSelect.value, sizeSelect.value);
    }

    function syncFirstUnit(card) {
      var firstUnit = card.querySelector('[data-pv-unit="1"]');
      if (!firstUnit || !variantIdInput) return;
      var v = updateUnitVariant(firstUnit);
      if (v) {
        variantIdInput.value = v.id;
        if (v.featured_image && v.featured_image.src) {
          syncGalleryToImage(v.featured_image.src);
        }
      }
    }

    function syncGalleryForRow(row) {
      var v = updateUnitVariant(row);
      if (v && v.featured_image && v.featured_image.src) {
        syncGalleryToImage(v.featured_image.src);
      }
    }

    function selectTier(card) {
      cards.forEach(function (c) {
        c.classList.remove('is-selected');
        var radio = c.querySelector('input[type="radio"]');
        if (radio) radio.checked = false;
        var units = c.querySelector('[data-pv-units]');
        if (units) units.hidden = true;
      });
      card.classList.add('is-selected');
      var radio = card.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      var units = card.querySelector('[data-pv-units]');
      if (units) units.hidden = false;

      var qty = parseInt(card.getAttribute('data-qty'), 10) || 1;
      if (quantityInput) quantityInput.value = qty;

      syncFirstUnit(card);
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (evt) {
        if (evt.target.closest('select')) return;
        selectTier(card);
      });
      var radio = card.querySelector('input[type="radio"]');
      if (radio) {
        radio.addEventListener('change', function () {
          selectTier(card);
        });
      }
      card.querySelectorAll('[data-pv-unit]').forEach(function (row) {
        row.querySelectorAll('select').forEach(function (select) {
          select.addEventListener('change', function () {
            if (row.getAttribute('data-pv-unit') === '1') {
              syncFirstUnit(card);
            } else {
              syncGalleryForRow(row);
            }
          });
        });
      });
    });

    var defaultCard = root.querySelector('[data-pv-tier].is-selected') || cards[0];
    if (defaultCard) selectTier(defaultCard);

    /* ---------- Add to cart (single unit = native form, bundle = multi-item fetch) ---------- */
    var form = document.querySelector('.pv-form');
    if (!form) return;

    document.addEventListener(
      'submit',
      function (evt) {
        if (evt.target !== form) return;

        var selectedCard = root.querySelector('[data-pv-tier].is-selected');
        var qty = selectedCard ? parseInt(selectedCard.getAttribute('data-qty'), 10) || 1 : 1;
        if (qty <= 1) return; // let Dawn's native product-form element handle it

        evt.preventDefault();
        evt.stopImmediatePropagation();

        var units = selectedCard ? selectedCard.querySelector('[data-pv-units]') : null;
        var items = [];
        for (var i = 1; i <= qty; i++) {
          var row = units ? units.querySelector('[data-pv-unit="' + i + '"]') : null;
          var variant = row ? updateUnitVariant(row) : null;
          if (variant) {
            items.push({ id: variant.id, quantity: 1 });
          } else if (variantIdInput) {
            items.push({ id: parseInt(variantIdInput.value, 10), quantity: 1 });
          }
        }
        if (!items.length) return;

        var submitButton = form.querySelector('[type="submit"]');
        if (submitButton) submitButton.setAttribute('aria-disabled', 'true');

        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var body = { items: items };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map(function (s) {
            return s.id;
          });
          body.sections_url = window.location.pathname;
        }

        fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (response) {
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(response);
            } else {
              window.location = window.routes ? window.routes.cart_url : '/cart';
            }
          })
          .catch(function (err) {
            console.error(err);
          })
          .finally(function () {
            if (submitButton) submitButton.removeAttribute('aria-disabled');
          });
      },
      true
    );
  }

  /* ---------- Review carousel (auto-rotate + dots) ---------- */
  function initCarousels() {
    document.querySelectorAll('[data-pv-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-pv-carousel-track]');
      var slides = carousel.querySelectorAll('[data-pv-carousel-slide]');
      var dots = carousel.querySelectorAll('[data-pv-carousel-dot]');
      if (!slides.length) return;
      var index = 0;
      var intervalMs = parseInt(carousel.getAttribute('data-interval'), 10) || 4000;

      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, si) {
          s.classList.toggle('is-active', si === index);
        });
        dots.forEach(function (d, di) {
          d.classList.toggle('is-active', di === index);
        });
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          show(i);
          restart();
        });
      });

      var timer = setInterval(function () {
        show(index + 1);
      }, intervalMs);

      function restart() {
        clearInterval(timer);
        timer = setInterval(function () {
          show(index + 1);
        }, intervalMs);
      }

      show(0);
    });
  }

  /* ---------- Swipeable carousel (3 visible desktop / 1 mobile, arrows + dots) ---------- */
  function initSwipeCarousels() {
    document.querySelectorAll('[data-pv-swipe-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-pv-swipe-track]');
      var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-pv-swipe-slide]'));
      var prevBtn = carousel.querySelector('[data-pv-swipe-prev]');
      var nextBtn = carousel.querySelector('[data-pv-swipe-next]');
      var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-pv-swipe-dot]'));
      if (!track || !slides.length) return;

      function goTo(index) {
        index = Math.max(0, Math.min(index, slides.length - 1));
        track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }

      function currentIndex() {
        var trackLeft = track.scrollLeft;
        var closest = 0;
        var closestDist = Infinity;
        slides.forEach(function (slide, i) {
          var dist = Math.abs(slide.offsetLeft - track.offsetLeft - trackLeft);
          if (dist < closestDist) {
            closestDist = dist;
            closest = i;
          }
        });
        return closest;
      }

      function updateDots() {
        var idx = currentIndex();
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === idx);
        });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex() - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex() + 1); });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); });
      });

      var scrollTimer = null;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(updateDots, 100);
      });

      updateDots();
    });
  }

  /* ---------- Autoplay muted videos once visible (pause when off-screen) ---------- */
  function initInlineVideos() {
    var videos = document.querySelectorAll('[data-pv-swipe-carousel] video, [data-pv-gallery] video');
    if (!videos.length || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.play().catch(function () {});
          } else {
            entry.target.pause();
          }
        });
      },
      { threshold: 0.5 }
    );
    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq() {
    document.querySelectorAll('[data-pv-faq-item]').forEach(function (item) {
      var trigger = item.querySelector('[data-pv-faq-trigger]');
      var panel = item.querySelector('[data-pv-faq-panel]');
      if (!trigger || !panel) return;
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        item.closest('[data-pv-faq]').querySelectorAll('[data-pv-faq-item]').forEach(function (other) {
          other.classList.remove('is-open');
          other.querySelector('[data-pv-faq-panel]').style.maxHeight = null;
        });
        if (!isOpen) {
          item.classList.add('is-open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  }

  /* ---------- Sticky add-to-cart bar ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-pv-sticky-atc]');
    var mainButton = document.querySelector('[data-pv-main-atc]');
    if (!bar || !mainButton || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // Only reveal once the button has actually been scrolled past (above the
          // viewport) — not merely "not intersecting", which is also true before the
          // user has scrolled down far enough to reach it in the first place.
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          bar.classList.toggle('is-visible', scrolledPast);
        });
      },
      { threshold: 0 }
    );
    observer.observe(mainButton);

    var stickyButton = bar.querySelector('[data-pv-sticky-atc-button]');
    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        var target = document.getElementById('buy-box') || mainButton;
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  /* ---------- Size guide anchor scroll ---------- */
  function initAnchorLinks() {
    document.querySelectorAll('[data-pv-scroll-to]').forEach(function (link) {
      link.addEventListener('click', function (evt) {
        var targetId = link.getAttribute('data-pv-scroll-to');
        var target = document.getElementById(targetId);
        if (!target) return;
        evt.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGallery();
    initBundle();
    initCarousels();
    initSwipeCarousels();
    initInlineVideos();
    initFaq();
    initStickyAtc();
    initAnchorLinks();
  });
})();
